module.exports = __webpack_public_path__ + "img/speedwork.68de538a.png";